import React from 'react';
import { Modal } from '../ui/Modal';
import { Spinner } from '../ui/Loading';
import { useModal } from '../../stores/uiStore';
import { useAssessment, useUpdateAssessment } from '../../hooks/api';
import { AssessmentUpdate } from '../../types/api';
import EnhancedAssessmentForm from './EnhancedAssessmentForm';

const EditAssessmentModal: React.FC = () => {
  const modal = useModal('edit-assessment');
  const assessmentId = modal.data?.assessmentId;
  
  const { data: assessment, isLoading: isLoadingAssessment } = useAssessment(
    assessmentId,
    modal.isOpen && !!assessmentId
  );
  
  const updateMutation = useUpdateAssessment();
  
  const handleSubmit = async (data: AssessmentUpdate) => {
    if (!assessmentId) return;
    
    try {
      await updateMutation.mutateAsync({ id: assessmentId, data });
      modal.close();
    } catch (error) {
      // Error handling is managed by the mutation
      console.error('Failed to update assessment:', error);
    }
  };
  
  const handleCancel = () => {
    modal.close();
  };
  
  if (isLoadingAssessment) {
    return (
      <Modal
        isOpen={modal.isOpen}
        onClose={handleCancel}
        size="xl"
      >
        <div className="flex items-center justify-center py-12">
          <Spinner size="lg" />
        </div>
      </Modal>
    );
  }
  
  if (!assessment) {
    return (
      <Modal
        isOpen={modal.isOpen}
        onClose={handleCancel}
        size="xl"
      >
        <div className="p-6 text-center">
          <p className="text-gray-500">Assessment not found</p>
        </div>
      </Modal>
    );
  }
  
  return (
    <Modal
      isOpen={modal.isOpen}
      onClose={handleCancel}
      size="xl"
    >
      <div className="p-6">
        <EnhancedAssessmentForm
          mode="edit"
          assessment={assessment}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={updateMutation.isPending}
        />
      </div>
    </Modal>
  );
};

export default EditAssessmentModal;
